function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 7.941,
  height: 1.273,
  transform: "translate(0.032 19.534)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M43.514,118.326H42.289s2.449-2.25,2.449-4.555c0-2.332-2.468-4.012-2.468-6.3a4.591,4.591,0,0,1,.622-2h1.215a4.453,4.453,0,0,0-.612,1.995c.019,1.959,2.488,3.984,2.468,6.34C45.943,116.35,43.514,118.326,43.514,118.326Z",
  transform: "translate(-42.27 -99.942)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M69.844,118.056H68.619s2.449-2.25,2.449-4.555c0-2.337-2.468-4.012-2.468-6.3a4.6,4.6,0,0,1,.622-2h1.215a4.457,4.457,0,0,0-.612,2c.019,1.959,2.488,3.989,2.468,6.34C72.273,116.081,69.844,118.056,69.844,118.056Z",
  transform: "translate(-66.041 -99.698)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M96.041,118.326H94.819s2.449-2.25,2.449-4.555c0-2.332-2.468-4.012-2.468-6.3a4.591,4.591,0,0,1,.622-2h1.215a4.457,4.457,0,0,0-.612,2c.019,1.959,2.488,3.984,2.468,6.34C98.47,116.35,96.041,118.326,96.041,118.326Z",
  transform: "translate(-89.696 -99.942)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M178.04,109.233V99.38h-1.166v9.853a3.059,3.059,0,1,0,1.166,0Z",
  transform: "translate(-161.559 -94.443)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M157.916,61.791V51.675h0a3.047,3.047,0,0,0-6.093-.107v.107h-.01V61.8a5.5,5.5,0,1,0,7.628,1.526A5.6,5.6,0,0,0,157.916,61.791Zm-3.049,8.91a4.33,4.33,0,0,1-1.885-8.23v-10.8h.01a1.881,1.881,0,0,1,3.761-.087v.087h0v10.8a4.33,4.33,0,0,1-1.885,8.23Z",
  transform: "translate(-138.957 -48.575)"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  width: 4.888,
  height: 1.224,
  transform: "translate(20.174 7.414)"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  width: 4.888,
  height: 1.224,
  transform: "translate(20.174 4.966)"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  width: 4.888,
  height: 1.224,
  transform: "translate(20.174 9.863)"
});

function SvgFussbodenheizung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.062,
    height: 23.304,
    viewBox: "0 0 25.062 23.304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFussbodenheizung);
export default __webpack_public_path__ + "static/media/fussbodenheizung.ed0fc4f53c815d6ae858f69973e126b9.svg";
export { ForwardRef as ReactComponent };